export function extractReportsList(payload) {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;

  const candidates = [
    payload.data,
    payload.reports,
    payload.dailyReports,
    payload.items,
    payload.docs,
    payload.results,
    payload.records,
    payload.list,
    payload.content,
    payload.data?.data,
    payload.data?.reports,
    payload.data?.dailyReports,
    payload.data?.items,
    payload.data?.docs,
    payload.data?.records,
    payload.data?.list,
    payload.data?.content,
  ];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) return candidate;
  }

  const deep = findReportArray(payload);
  return deep ?? [];
}

function findReportArray(value, depth = 0) {
  if (!value || depth > 4) return null;

  if (Array.isArray(value)) {
    if (value.length === 0) return value;
    if (looksLikeReport(value[0])) return value;
    return null;
  }

  if (typeof value === "object") {
    for (const nested of Object.values(value)) {
      const found = findReportArray(nested, depth + 1);
      if (found) return found;
    }
  }

  return null;
}

function looksLikeReport(item) {
  if (!item || typeof item !== "object") return false;
  return Boolean(
    item._id ||
    item.id ||
    item.projectName ||
    item.project ||
    item.summary ||
    item.tasksCompleted
  );
}

export function normalizeDailyReport(report) {
  if (!report) return null;

  const preparedBy =
    report.preparedBy ??
    report.submittedBy ??
    report.createdBy ??
    report.user ??
    null;

  return {
    _id: report._id ?? report.id,
    projectName: report.projectName ?? report.project ?? "",
    summary: report.summary ?? "",
    tasksCompleted: report.tasksCompleted ?? "",
    tasksInProgress: report.tasksInProgress ?? "",
    nextSteps: report.nextSteps ?? "",
    notes: report.notes ?? "",
    createdAt: report.createdAt ?? report.date ?? report.submittedAt ?? null,
    preparedBy: typeof preparedBy === "object"
      ? preparedBy
      : preparedBy
        ? { userName: String(preparedBy) }
        : null,
  };
}

export function toLocalDateKey(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function matchesDateFilter(createdAt, dateFilter) {
  if (!dateFilter) return true;
  return toLocalDateKey(createdAt) === dateFilter;
}
